<template>
  <div id="app">
    <MainNav/>

    <router-view/>

    <div id="footer">
      <section class="uk-container footer-roos padding-15-important">
        <h2 class="footer-header-text uk-padding-remove">ROOS NETJES • VOICE-OVER • ACTRICE</h2>
        <div class="
          uk-flex
          uk-flex-between
          uk-flex-wrap
          uk-flex-wrap-middle
          footer
          footer-links
        ">
          <a href="http://marbleagency.amsterdam/actrices/roos-netjes" target="_blank" class="uk-navbar-item uk-width-auto@s
          footer-links-text">
            Actrice
          </a>
          <router-link to="/over-roos" class="uk-navbar-item uk-width-auto@s footer-links-text">
            Over Roos
          </router-link>
          <router-link :to="{ path: '/', hash: '#mijnTarieven' }"
                       class="uk-navbar-item uk-width-auto@s footer-links-text">
            Tarieven
          </router-link>
          <router-link :to="{ path: '/', hash: '#contactFormTwo' }" class="
          uk-navbar-item uk-width-auto@s footer-links-text">
            Voice-Over Aanvragen
          </router-link>
          <router-link :to="{ path: '/', hash: '#contactFormThree' }" class="
          uk-navbar-item uk-width-auto@s footer-links-text">
            Contact
          </router-link>
        </div>
        <div class="
          uk-flex
          uk-flex-center
          uk-flex-wrap
          uk-flex-wrap-middle
          footer
        ">
          <a href="https://www.instagram.com/roosnetjes/" target="_blank"
             class="uk-padding-small">
            <img :src="require('@/assets/images/icons/instagram.svg')"
                 alt="Instagram"
                 style="width: 30px;"
                 uk-svg
            />
          </a>
        </div>
        <div class="
          uk-flex
          uk-flex-center
          uk-flex-wrap
          uk-flex-wrap-middle
          footer
          footer-copyright
        ">© 2022 Patrick van der Plas - Iungo IT</div>

      </section>

    </div>
  </div>
</template>

<script>
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import Audio from '@/audio-bus';
import MainNav from '@/components/MainNav.vue';

const { AudioBus } = Audio;

UIkit.use(Icons);
UIkit.navbar('#nav', {});
UIkit.sticky('#sticky-nav', {});

export default {
  name: 'App.vue',
  components: {
    MainNav,
  },
  computed: {
    icon: () => (AudioBus.playing ? 'icon: file; ratio: 1.1' : 'icon: play; ratio: 1.1'),
  },
  data() {
    return {
      playing: false,
    };
  },
};
</script>

<style lang="scss">
  // Own variables
  @import 'assets/theme/variables';

  // UIKit variables
  @import '~uikit/src/scss/variables-theme';
  @import '~uikit/src/scss/mixins-theme';

  // Override mixins
  @import 'assets/theme/mixins';

  // Putting it together
  @import '~uikit/src/scss/uikit-theme';

  // Other external resources
  @import '~hamburgers/_sass/hamburgers/hamburgers';

  @import 'assets/theme/styles';

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

</style>
